<template>
  <accounts-component-template component-key="security" component-name="Security" color="#666">
    <template v-slot:icon>
      <security-icon :size="16" />
    </template>
    <template v-slot:content>
      <h3>Multi-Factor Authentication</h3>
      <div class="account-details-formfield">
        <div class="account-details-checkboxfield m-bt-15" @click="(event) => update(!securitySettings.mfaEnabled)">
          <input type="checkbox" :checked="securitySettings.mfaEnabled" />
          <span>Enable mandatory MFA (Multi-Factor Authentication)</span>
        </div>

        <p>
          When left unchecked, users will still have the option to
          enable MFA for their own individual account.
          <a href="/admin/feature-flag">Enable the Elastic Feature Flag EMAIL_MFA to enable this tab</a>
        </p>
      </div>
    </template>
  </accounts-component-template>
</template>

<style>
  .m-bt-15 {
    margin-bottom: 13px !important;
  }
</style>

<script>
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import {SecurityIcon} from '../icons';
import {mapActions, mapGetters} from 'vuex';

export default {

  props: {},

  components: {
    AccountsComponentTemplate,
    SecurityIcon,
  },

  data () {
    return {

      enable_mfa: false
    }
  },

  computed: {
      ...mapGetters('AdminAccountDetailsStore', [
          'securitySettings',
          'accountId'
      ])
  },

  methods: {

    ...mapActions('AdminAccountDetailsStore', [
        'updateMfaSetting',
    ]),

    update (isEnabled) {
      let payload = {
          isEnabled,
          accountId: this.accountId,
      };

      this.updateMfaSetting(payload).then(result => {
          if (!result) {
              console.error('update mfa settings error');
          }
      })
    },
  }
}
</script>
